<template>
  <div class="member mk-flex-column-start-center">
    <img class="member-img" :src="topBg">
    <div class="member-main mk-flex-column-start-center">
      <div class="member-title mk-flex-row-center-center">
        <div class="member-title-spot"></div>
        <span class="member-title-text">核心团队</span>
        <div class="member-desc">CORE TEAM</div>
      </div>
    </div>
    <img class="member-framework-img" :src="frameworkBg">
    <!-- <img class="intro-bottom-img" :src="bottomBg"> -->
    <div class="member-swipe">
      <swiper :options="swiperOption" class="member-swipe-main" :style="swiperHeight">
        <!-- <swiper-slide v-for="(item, index) in bgImgs" :key="index">
          <img class="swiper-slide-img" :src="item">
        </swiper-slide> -->
        <swiper-slide v-for="(item, index) in bgImgHeaders" :src="item" :key="index">
          <div class="swiper-slide-header mk-flex-row-start-center">
            <div
              class="swiper-slide-img-header mk-flex-column-start-center"
              v-for="(itm, idx) in item.headers" :key="idx"
              @click="showInfo(itm.name)">
              <div class="header-url">
                <img class="header-url-img" :src="itm.url">
              </div>
              <div class="header-desc mk-flex-column-center-center">
                <p>
                  <span class="desc-name">{{itm.name}}</span>
                  <span>{{itm.title}}</span>
                </p>
                <p class="occupation">{{itm.occupation}}</p>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
    <div class="layout"></div>
    <el-dialog
      :visible.sync="dialogVisible"
      @close="closeDialog"
      width="1030px">
      <member-info :currentName="currentName"></member-info>
    </el-dialog>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import memberInfo from '@/components/memberInfo.vue'
export default {
  name: 'member',
  components: {
    swiper,
    swiperSlide,
    memberInfo
  },
  data () {
    return {
      dialogVisible: false,
      currentName: '',
      topBg: require('@/assets/img/member-top-bg.png'),
      frameworkBg: require('@/assets/img/member-framework-bg.png'),
      bgImgs: [
        require('@/assets/img/member-item.png'),
        require('@/assets/img/member-item.png')
      ],
      bgImgHeaders: [
        {
          headers: [
            {
              url: require('@/assets/img/liuyanfei.png'),
              name: '刘燕飞',
              title: '（主席）',
              occupation: '护士学硕士、副主任护师'
            },
            {
              url: require('@/assets/img/liuxiaohong.png'),
              name: '刘晓红',
              title: '（副主席）',
              occupation: '护理学硕士，副主任护师'
            },
            {
              url: require('@/assets/img/gejieying.jpg'),
              name: '葛洁英',
              title: '（副主席）',
              occupation: 'CRC/CRN专业组组长'
            },
            {
              url: require('@/assets/img/zhaoqing.png'),
              name: '赵青',
              title: '（副主席）',
              occupation: '食品药品监督管理局GCP检查员'
            }
          ]
        }
      ],
      swiperHeight: 'height: 385px;',
      // swiper配置数据
      swiperOption: {
        autoplay: {
          delay: 3000, //自动切换的时间间隔，单位ms
          stopOnLastSlide: true, //如果设置为true，当切换到最后一个slide时停止自动切换。
          disableOnInteraction: true, //用户操作swiper之后，是否禁止autoplay。
          reverseDirection: true, //开启反向自动轮播。
          waitForTransition: true, //等待过渡完毕。自动切换会在slide过渡完毕后才开始计时。
        },
        navigation: {
          nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: 'my-button-disabled', //前进后退按钮不可用时的类名。
          hiddenClass: 'my-button-hidden', //按钮隐藏时的Class
        }
      }
    }
  },
  methods: {
    closeDialog () {
      this.dialogVisible = false
    },
    showInfo (name) {
      this.currentName = name
      this.dialogVisible = true
    }
  }
}
</script>
<style lang="css" src="./../assets/css/swiper.css"></style>
<style scoped>
  img {
    vertical-align: bottom;
  }
  .member {
    width: 100%;
    background-color: #F9F9F9;
  }
  .member-img {
    width: 100%;
    height: 388px;
  }
  .member-main {
    width: 100%;
  }
  .member-title {
    margin-top: 44px;
    position: relative;
  }
  .member-title-spot {
    width: 22px;
    height: 22px;
    background-image: linear-gradient(90deg, #4144B1 9%, #2859D1 99%);
    margin-right: 24px;
  }
  .member-title-text {
    height: 67px;
    font-size: 48px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2B2D97;
    line-height: 67px;
    letter-spacing: 7px;
  }
  .member-desc {
    position: absolute;
    left: 94px;
    top: 26px;
    width: 317px;
    height: 62px;
    font-size: 44px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #99B3DD;
    line-height: 62px;
    letter-spacing: 3px;
    z-index: -1;
    opacity: 0.19;
  }
  .member-framework-img {
    margin-top: 79px;
    width: 990px;
    height: 352px;
    margin: auto;
  }
  .member-swipe {
    width: 990px;
    height: 385px;
    position: relative;
    margin: auto;
  }
  .member-swipe-main {
    width: 920px;
    height: 100%;
  }
  .swiper-slide-img {
    width: 100%;
    height: 100%;
  }
  .swiper-slide-img-header {
    width: 200px;
    height: 325px;
    margin-left: 40px;
  }
  .swiper-slide-img-header:first-child {
    margin-left: 0px;
  }
  .header-url {
    width: 200px;
    height: 260px;
    overflow-y: scroll;
  }
  .header-url-img {
    width: 100%;
    min-height: 260px;
  }
  .header-desc {
    width: 100%;
    height: 65px;
    color: #ffffff;
    background-color: #2859D1;
    font-size: 12px;
  }
  .desc-name {
    font-size: 22px;
    font-weight: 800;
  }
  .swiper-button-next {
    right: -10px;
    background-image: url("./../assets/img/icn-arrow-blue-right.png");
  }
  .swiper-button-prev {
    left: -10px;
    background-image: url("./../assets/img/icn-arrow-blue-left.png");
    transform: rotate(0deg);
  }
  .swiper-slide-header {
    width: 100%;
    height: 100%;
    /* border: 1px solid red; */
  }
  .occupation {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }
  .layout {
    height: 128px;
  }
</style>
